<template>
  <div class="video_wrappers">
    <div class="video_banner">
      <!-- <video
                controls='controls'
                autoplay='autoplay'
                loop='loop'
                :width="vedios.width"
                :height="vedios.height"
            >
                <source
                    :src="vedios.vediotile"
                    type="video/mp4"
                >
            </video> -->
      <div class="vedioback">
        <img
          src="../assets/img/main/active.gif"
          alt=""
          style="object-fit:contain;;max-width:79%;height:100%;vertical-align:middle;_width:expression(this.width > 79%? 79% : this.width);"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    vedios: Object
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.video_wrappers {
  box-sizing: border-box;
  width: 636px;
  height: 360px;
  .video_banner {
    width: 100%;
    height: 100%;
    video {
      width: 100%;
    }
    .vedioback {
      width: 100%;
      height: 100%;
      padding: 10px 10px 24px 10px;
      box-sizing: border-box;
      background: url("../assets/img/main/computer.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>
